import { render } from "./PublicHero.vue?vue&type=template&id=0c82878f"
import script from "./PublicHero.vue?vue&type=script&lang=js"
export * from "./PublicHero.vue?vue&type=script&lang=js"

import "./PublicHero.vue?vue&type=style&index=0&id=0c82878f&lang=css"

import exportComponent from "C:\\MesProjets\\Labs\\akdevmatik\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__